export default __webpack_public_path__ + "c9c5aa6e77bdc9cb9e824c3d188da347.png";